import { Text, styled } from '@applatform/design-system';

const Heading = styled(Text, {
  color: '$primary',
  fontWeight: '$medium',
});

export default Heading;
